const Question = ({ ...props }) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 12.54a.847.847 0 1 0 0 1.694.847.847 0 0 0 0-1.694Zm.232-.725h-.484a.363.363 0 0 1-.363-.363v-.012c0-2.127 2.342-1.924 2.342-3.248 0-.605-.537-1.216-1.737-1.216-.881 0-1.339.292-1.79.868a.362.362 0 0 1-.492.071l-.397-.276a.362.362 0 0 1-.08-.52c.642-.823 1.403-1.353 2.759-1.353 1.582 0 2.947.9 2.947 2.426 0 2.039-2.342 1.93-2.342 3.248v.012c0 .2-.163.363-.363.363ZM10 3.468a6.533 6.533 0 1 1-.002 13.066A6.533 6.533 0 0 1 10 3.468Zm0-.968a7.501 7.501 0 0 0 0 15 7.5 7.5 0 1 0 0-15Z"
      fill="#646464"
    />
  </svg>
)

export default Question
